<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h2 class="w-100">
        Sub-admins
        <span class="d-flex right_blocks">
          <select
            class="form-control"
            (change)="onChangeYear($event)"
            [ngModel]="currentYear"
          >
            <option disabled>Select year</option>
            <option *ngFor="let yrs of years" [value]="yrs.name">
              {{ yrs.name }}
            </option>
          </select>

          <input
            type="text"
            class="form-control"
            [(ngModel)]="search"
            placeholder="Search"
          />
        </span>
      </h2>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="white_box shadow p-3">
          <nz-tabset nzType="card" class="completed_repairs">
            <nz-tab
              *ngFor="let mont of subadmins; let i = index"
              [nzTitle]="mont.month"
            >
              <div class="table-responsive contact_new_table table_contact">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">id</th>
                      <!-- <th scope="col">Name</th> -->
                      <th scope="col">Email</th>
                      <th scope="col">Credits left</th>
                      <th scope="col">Credits used</th>
                      <!-- <th scope="col">Mobile Number</th> -->
                      <th scope="col">Whatsapp Number</th>
                      <th scope="col">Date</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let i of mont.data | newSubadmin : search;
                        let n = index
                      "
                    >
                      <td>{{ n + 1 }}</td>
                      <!-- <td>
                        {{ i.user_detail.first_name }}
                        {{ i.user_detail.last_name }}
                      </td> -->
                      <td>{{ i.email }}</td>
                      <td>{{ i.totalTokens - i.usedTokens }}</td>
                      <td>{{ i.usedTokens }}</td>
                      <!-- <td>{{ i.user_detail.phone_number }}</td> -->
                      <td>{{ i.user_detail.w_phone_number }}</td>
                      <td>{{ i.createdAt * 1000 | date : "longDate" }}</td>
                      <td>
                        <i
                          class="fas fa-clock"
                          (click)="login_history(login_history_modal, i.id)"
                        ></i>
                        &nbsp;

                        <i
                          class="fas fa-ban"
                          (click)="block_unblock_user(i.id)"
                          *ngIf="i.is_blocked == 0"
                        ></i>
                        <i
                          class="fas fa-user-lock"
                          (click)="block_unblock_user(i.id)"
                          *ngIf="i.is_blocked == 1"
                        ></i>
                        &nbsp;

                        <div
                          *ngIf="
                            i.sub_lock == '-1';
                            then thenTemplateName;
                            else elseTemplateName
                          "
                        ></div>

                        <ng-template #thenTemplateName>
                          <i
                            class="fa-solid fa-lock"
                            id="lockedb"
                            (click)="lockopen(i.id, '0')"
                          ></i>
                        </ng-template>

                        <ng-template #elseTemplateName>
                          <i
                            class="fa-solid fa-lock-open"
                            id="unlockedb"
                            (click)="lockopen(i.id, '1')"
                          ></i>
                        </ng-template>
                        &nbsp;
                        <i
                          class="fa-solid fa-pen-to-square"
                          (click)="edit_profile_details(i.id)"
                        ></i>
                        &nbsp;
                        <i
                          class="fas fa-dollar-sign"
                          (click)="open_transaction_listing(i.id)"
                        ></i>
                        &nbsp;
                        <i
                          class="fas fa-trash"
                          (click)="delete_user(delete_user_modal, i.id)"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p class="empty" *ngIf="mont.dataLength == 0">No data found</p>
              </div>
            </nz-tab>
          </nz-tabset>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #delete_user_modal let-modal>
  <div id="delete_user_modal" class="login_me" role="dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <button
        type="button"
        style="outline: none"
        class="close close_modal"
        (click)="modal.dismiss('Cross click')"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-header">
        <h5 class="modal_title_2">
          <span>DELETE USER</span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="admin_member">
          <img loading="lazy" src="../../../assets/images/logo.png" class="logo" />
          <p>Admin Password</p>
        </div>
        <form class="member_status_form">
          <div class="row">
            <div class="col-md-7 mx-auto">
              <div class="form-row"></div>
              <ng-container>
                <ng-otp-input
                  #ngOtpInput
                  (onInputChange)="onOtpChange($event)"
                  [config]="{
                    length: 4,
                    allowNumbersOnly: true,
                    disableAutoFocus: true
                  }"
                ></ng-otp-input>
              </ng-container>
            </div>

            <div class="col-md-12">
              <a class="sign_in" (click)="onDeleteData()"> Enter </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #login_history_modal let-modal>
  <div id="login_history_modal" class="login_me" role="dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <button
        type="button"
        style="outline: none"
        class="close close_modal"
        (click)="modal.dismiss('Cross click')"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-header">
        <h5 class="modal_title_2">
          <span>LOGIN HISTORY</span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 login_history_table">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <th scope="col">Sr.No.</th>
                  <th scope="col">Login Time</th>
                  <th scope="col">Admin Name</th>
                  <th scope="col">IP</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let i of user_login_history_list; let a = index">
                  <th scope="row">{{ a + 1 }}</th>
                  <td>
                    {{ i.login_time * 1000 | date : "medium" }}
                    <span class="relative_time">({{ i.relative_time }})</span>
                  </td>
                  <td>{{ i.fn }} {{ i.ln }}</td>
                  <td>{{ i.ip }}</td>
                </tr>
              </tbody>
            </table>
            <p *ngIf="user_login_history_list_length == 0">
              Login history not found
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
